import React, {useState} from "react";
import { Input, Alert, Form, Select } from 'antd';
import AxiosRequest from "../helpers/AxiosRequest";
import { Redirect } from 'react-router-dom';
import { NavLink } from "react-router-dom";

const { Search } = Input;
const {Option} = Select;

const ChooseImba = () => {

    const [error, setError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [succes, setSuccess] = useState(false);
    const [widgets, setWidgets] = useState([
        {
            id: 0,
            host: 0
        }
    ]);
    const [widget, setWidget] = useState(0);

    const chooseWidget = (value) => {
        
        setWidget(value);
        
        return (
            <Redirect to = {{ pathname: `/${value}/signIn?reload=1` }} />
        );
    }

    const onSearch = (value) => {
        if (value)
        {
            AxiosRequest('imba_get_widgets', {
                email: value
            }).then((response) => {
                let data = response;
                if (!data.success)
                {
                    setError(true);
                    setErrorMsg(data.errorMsg);
                    return;
                }
                setError(false);
                setSuccess(true);
                setWidgets(data.widgets);
            }).catch((error) => {
            })
        }
    }

    const Options = () => {
        const children = [];
        widgets.map((item, index) => {
            children.push(
                <Option value={item.id}>{item.host} - {item.id}</Option>
            )
        })
        return children;
    }

    return widget != 0 ? (
        <Redirect redirect ={1} to = {{ pathname: `/${widget}/signIn` }} />
    ) : (
        <div className={'form-group'}>
            <Form
                name="basic"
            >
                <Form.Item
                    name="email"
                    rules={[{ required: true, message: 'Please input your email!' }]}
                >
                    <label>Login in imbachat.com</label>
                    <Search
                        placeholder="login"
                        allowClear
                        enterButton="Search"
                        size="large"
                        onSearch={onSearch}
                    />
                </Form.Item>

                <Form.Item
                    hidden={!error}
                >
                    <Alert
                        message={errorMsg}
                        type="error"
                        showIcon
                    />
                </Form.Item>
                <Form.Item hidden={!succes}>
                    <Select onChange={chooseWidget}>
                        {Options()}
                    </Select>
                </Form.Item>
            </Form>
        </div>
    )
}

export default ChooseImba;